import React, { useEffect } from "react";
import { useState } from "react";
import styles from "../../css/plugins.module.css";
import PluginsOptional from "./PluginsOptional";
import PluginsBuiltIn from "./PluginsBuiltIn";

/**
 * Id-jevi koje ovaj kod ume da upotrebi — isti spisak koji drži
 * `apps/backend/blockchain/plugins/manifest.js`.
 *
 * Stoji ovde kao obična lista, a ne izvodi se iz kataloga, jer katalog nabraja
 * samo UVOZNE plugin-e (`kind === "import"`), a ovaj spisak treba i one druge:
 * Encryption, Backup, Export data, Hot Key, Explorer Lite, AI. Kad se doda nov
 * plugin, dopuniti i ovde.
 */
const POZNATI_ID = [1, 2, 5, 6, 7, 8, 9, 10, 11, 12];

const PluginsMain = ({ plugins, userPlugins, refreshData }) => {
  const [tabItem, setTabItem] = useState(true);
  const [optional, setOptional] = useState([]);
  const [builtin, setBuiltin] = useState([]);

  useEffect(() => {
    // Registar sa lanca se uzima onakav kakav jeste — uključujući i unose koje
    // ovaj kod ne poznaje. Takav se ne može upotrebiti: nijedna ruta, nijedna
    // forma i nijedna provera ne pominju njegov id, pa „Install" na njemu ne
    // radi ništa. Na TAS-u je 28.09.2026. tako stajao `13 SQL Import`, unet
    // ručno, dok kod isti plugin zna kao `11 MySQL Import`.
    //
    // Sa lanca se ne može obrisati — kontrakt ima samo „dodaj". Zato se ovde
    // preskače: bolje da ga nema nego da nudi dugme koje ne radi.
    const poznat = (plugin) => POZNATI_ID.includes(Number(plugin.id));

    // Redosled na lancu je redosled UPISA, ne brojeva: `addpluging` dopisuje na
    // kraj, pa je `11` dodat posle `12` i u spisku stajao poslednji. Sortira se
    // ovde, jer se na lancu ne da preurediti.
    const poRedu = (a, b) => Number(a.id) - Number(b.id);

    const svi = plugins?.plugins?.filter(poznat);
    setOptional(svi?.filter((p) => p.required === 0).sort(poRedu));
    setBuiltin(svi?.filter((p) => p.required === 1).sort(poRedu));
  }, [plugins]);

  return (
    <div className={`${styles.pluginsWrapper} container`}>
      <div className={styles.pluginsHead}>
        <h2>Plugins</h2>
        <p>
          Empower your database with optional and built-in Plugins. See the
          options below.
        </p>
      </div>
      <ul className={styles.pluginsNavigate}>
        <li>
          <button
            className={`${tabItem ? styles.active : ""}`}
            onClick={() => setTabItem(true)}
          >
            Optional
          </button>
        </li>
        <li>
          <button
            className={`${tabItem ? "" : styles.active}`}
            onClick={() => setTabItem(false)}
          >
            BuiltIn
          </button>
        </li>
      </ul>
      <hr></hr>
        {tabItem ? (
          <PluginsOptional
            items={optional}
            userPlugins={userPlugins?.plugins}
            refreshData={refreshData}
          />
        ) : (
          <PluginsBuiltIn
            items2={builtin}
            userPlugins={userPlugins?.plugins}
            refreshData={refreshData}
          />
        )}
    </div>
  );
};

export default PluginsMain;
